import { Label } from "@components/inputs/field";
import { InnerLabel } from "@components/inputs/field/Label.styles";
import SmartFastEntryList from "@components/smart/smartFastEntryList";
import styled from "styled-components";


export const SmartFastEntryListStyled = styled(SmartFastEntryList)`
`;

export const LabelStyled = styled(Label)`
    font-weight: normal;
    margin: 25px 0 17px 0;
    
    ${InnerLabel} {
        white-space: normal;
    }
`;

export const CareGivingLabelStyled = styled(Label)`
    font-weight: normal;
`;

export const ExportTextWrapper = styled.div`
    white-space: nowrap;
    padding: 12px 30px 0 12px;
    
    svg {
        display: inline-flex;
        vertical-align: bottom;
    }
`;